import type { CareTeamPatientCard } from '../../services/api/types.gen';
import { fitName } from './fitText';
import { FittedText } from './FittedText';
import { patientSubtitle } from './windowHeader';

/** Title and subtitle of a conversation header, shared by the floating window and the phone sheet. */
export function ConversationHeaderText({
  card,
  title,
  subtitle,
  titleId,
}: {
  card: CareTeamPatientCard | null | undefined;
  title: string;
  subtitle: string;
  titleId?: string;
}) {
  return (
    <div className='min-w-0 flex-1'>
      <p id={titleId} className='truncate text-sm font-semibold'>
        {card ? (
          <FittedText
            text={`${card.first_name} ${card.last_name}`}
            fit={fits => fitName(card.first_name, card.last_name, fits)}
          />
        ) : (
          title
        )}
      </p>
      <p className='truncate text-[11px] text-muted-foreground'>
        {card ? (
          <>
            <span className='sr-only'>Patient care team. </span>
            {patientSubtitle(card)}
          </>
        ) : (
          subtitle
        )}
      </p>
    </div>
  );
}
